module.exports = __webpack_public_path__ + "img/seme_1kl.8e02090b.jpg";